module.exports = __webpack_public_path__ + "media/src/images/landing/stars-c36420fd70798bb1554d03502c453c66.svg";